import { render, staticRenderFns } from "./user-wizard-setup.vue?vue&type=template&id=49d58bcf&scoped=true&"
import script from "./user-wizard-setup.vue?vue&type=script&lang=js&"
export * from "./user-wizard-setup.vue?vue&type=script&lang=js&"
import style0 from "./user-wizard-setup.vue?vue&type=style&index=0&id=49d58bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d58bcf",
  null
  
)

export default component.exports